import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11ec7046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide-content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Notifications"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-body-large" }, "We can notify you with a daily notification about new deviations and HoC ratings"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/feature/onboarding/notification.svg",
    style: {"max-width":"35%"}
  })
], -1))
const _hoisted_3 = { class: "slide-bottom-navigation" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Turn on notification")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Skip for now")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ion_button, {
        expand: "block",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.completeOnboarding(_ctx.NotificationMode.Daily)))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_ion_button, {
        color: "secondary",
        expand: "block",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.completeOnboarding(_ctx.NotificationMode.None)))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}